import { Quote } from 'lucide-react';
import { Reveal } from './Reveal';

export default function QuoteBanner() {
  return (
    <section
      data-testid="ceo-quote-banner"
      aria-label="Leadership quote"
      className="grain-dark relative overflow-hidden bg-royal-ink py-16 lg:py-24"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 bottom-0 h-72 w-72 rounded-full bg-royal/50 blur-3xl" />
        <div className="absolute -right-16 top-0 h-64 w-64 rounded-full bg-lime/10 blur-3xl" />
      </div>
      <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6 lg:px-8">
        <Reveal>
          <Quote className="mx-auto h-9 w-9 rotate-180 text-lime" fill="currentColor" strokeWidth={0} aria-hidden="true" />
          <blockquote className="mt-6 font-display text-2xl font-extrabold leading-snug tracking-tight text-white sm:text-3xl lg:text-[2.5rem] lg:leading-[1.25]">
            &ldquo;Committed to creating a culture of accountability, collaboration, and continuous growth while
            leading Sania Job Bowl toward long-term success.&rdquo;
          </blockquote>
          <p
            className="mt-7 font-mono text-[11px] font-semibold uppercase tracking-[0.28em] text-lime"
            data-testid="quote-attribution"
          >
            Puvvala Nagaraju · Chief Executive Officer
          </p>
        </Reveal>
      </div>
    </section>
  );
}
